import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import { spacing } from "../../util/spacing";
import mediaQueries from "../../util/mediaqueries";
import styled from 'styled-components';
export var Container = styled.div.withConfig({
  componentId: "sc-19eg7ds-0"
})(["display:flex;flex-wrap:wrap;gap:", ";width:100%;flex-direction:column;align-content:center;", " ", ""], spacing(3), mediaQueries.xs(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: auto;\n  "]))))), mediaQueries.sm(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-direction: row;\n  "]))))));